import React from 'react'
import { CommerceBoxPromoProps } from './CommerceBox.types'
import PriceTag from './PriceTag'

const CommerceBoxPromo = ({ product, PromoCode }: CommerceBoxPromoProps) => {
  const { price, c_basePrice, c_priceDiscounted, c_minSetPrice, currency } =
    product
  return (
    <>
      <PriceTag
        className='grid auto-cols-fr grid-flow-col grid-cols-[auto] items-center gap-4'
        discountPrice={c_priceDiscounted}
        c_basePrice={c_basePrice}
        price={c_minSetPrice || price}
        smallDiscountPrice={false}
        showTaxesInfo={true}
        currency={currency}
        isPDP={true}
        alignBasePriceRight
      />
      {PromoCode}
    </>
  )
}

export default CommerceBoxPromo
